<template>
  <div>
    <div class="container">招标编号:{{this.id}}</div>
    <div class="container">这里放进度图</div>
    <div class="chooseFactory">
      <div class="title">
        <p>选择厂商</p>
      </div>
      <el-row :gutter="20">
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane label="全部厂商" name="first">
                <el-col :span="24">
                  <el-col :span="12">
                    <el-col :span="20">
                      <el-input v-model="factory" placeholder="请输入内容" ></el-input>
                    </el-col>
                    <el-col :span="4">
                      <el-button type="primary" @click="searchFactory()">搜索</el-button>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col :span="22">
                  <el-radio-group v-model="radio" @change="radioChange()">
                    <el-radio-button label="综合">
                      综合
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                    <el-radio-button label="报工率">
                      报工率
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                    <el-radio-button label="准时率">
                      准时率
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="24">
                  <div v-for="(item,index) in factoryAllData" :key="index" >
                    <div v-if="item.hidden != true">
                      <router-link
                        tag="a"
                        :to="{
                        name:'FactoryInfo',
                        query: {   
                                id: item.factory_id, // orderNum : this.searchData.orderNo
                                type:item.type
                            }
                        }"
                      >
                        <el-col :span="8">
                          <img :src="item.picture" alt width="250px" />
                        </el-col>
                        <el-col :span="13">
                          <h3>{{item.factory_name}}</h3>
                          <p>{{item.address}}</p>
                          <p>{{item.special_skill}}</p>
                          <p>{{item.output_value}}</p>
                          <p>{{item.process_types}}</p>
                        </el-col>
                      </router-link>
                      <el-col :span="3">
                        <div class="icon">
                          <i class="el-icon-star-off " v-if="item.collect == false" @click="collect(index)"></i>
                          <i class="el-icon-star-on " v-if="item.collect == true" @click="collect(index)"></i>
                        </div>
                        <div class="el-button el-button-xzcs" @click="choose(index,item)">选择厂商</div>
                      </el-col>
                      <hr />
                    </div>
                    
                  </div>
                  <el-pagination class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formData.page"
                    :page-sizes="[20,60,100,140]"
                    :page-size="formData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="countAll"
                  ></el-pagination>
                </el-col>
              </el-tab-pane>
              <el-tab-pane label="收藏厂商" name="second" >
                <el-col :span="24">
                  <el-col :span="12">
                    <el-col :span="20">
                      <el-input v-model="factory" placeholder="请输入内容"></el-input>
                    </el-col>
                    <el-col :span="4">
                      <el-button type="primary">搜索</el-button>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col :span="22">
                  <el-radio-group v-model="radio" @change="radioChange()">
                    <el-radio-button label="综合">
                      综合
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                    <el-radio-button label="报工率">
                      报工率
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                    <el-radio-button label="准时率">
                      准时率
                      <i :class="x ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
                    </el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="24">
                  <div v-for="(item,index) in factoryCollectData" :key="index" >
                    <div v-if="item.hidden != true">
                      <router-link
                        tag="a"
                        :to="{
                        name:'FactoryInfo',
                        query: {   
                                id: item.factory_id, // orderNum : this.searchData.orderNo
                                type:item.type
                            }
                        }"
                      >
                        <el-col :span="8">
                          <img :src="item.picture" alt width="250px" />
                        </el-col>
                        <el-col :span="13">
                          <h3>{{item.factory_name}}</h3>
                          <p>{{item.address}}</p>
                          <p>{{item.special_skill}}</p>
                          <p>{{item.output_value}}</p>
                          <p>{{item.process_types}}</p>
                        </el-col>
                      </router-link>
                      <el-col :span="3">
                        <div class="icon">
                           
                          <i class="el-icon-star-on " @click="CancelCollect(index)"></i>
                        </div>
                        <a href="#" class="el-button el-button-xzcs" @click="choose(index,item)">选择厂商</a>
                      </el-col>
                      <hr />
                    </div>
                  </div>
                  <el-pagination class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formData.page"
                    :page-sizes="[20,60,100,140]"
                    :page-size="formData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="countCollect"
                  ></el-pagination>
                </el-col>
              </el-tab-pane>
              
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-col :span="24">
              <div class="bg-purple cs-title">已选厂商</div>
            </el-col>
            <el-col :span="24">
              <div v-for="(item,index) in factoryChoose" :key="index" @click="cancel(index)">
                <h3><i class="el-icon-remove-outline remove"></i>{{item.factory_name}}</h3>
                
                <br />
              </div>
              <a class="el-button el-button--primary" @click="launchTender()">确认发起招标</a>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>确定取消收藏吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog(false)">取 消</el-button>
        <el-button type="primary" @click="dialog(true)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {

  name: "ChooseFirm",
  data() {
    return {
      formData: {
        page: 1,
        limit: 20,
        type:'全部工厂'
      },
      countAll:0,
      countCollect:0,
      activeName: "first",
      id: "",
      factory: "",
      factoryAllData: [],
      factoryCollectData: [],
      factoryChoose: [],
      orderType: "asc",
      x: true,
      radio: "",
      centerDialogVisible: false,
      cancelCollect:0,
    };
  },

  methods: {
    searchFactory() {
      this.$http
        .post("/v2/validate/SearchFactory", {
          factory: this.factory,
          formData: this.formData
        })
        .then(res => {
          this.factoryAllData = res.data.factoryAll;
          this.countAll = res.countAll;
          this.factoryCollectData = res.data.factoryCollect;
          this.countCollect = res.countCollect;
        })
        .catch(error => {
          console.log(error);
        });
    },
    choose(e , item) {
      this.factoryChoose.push(item);
      let numAll = search(this.factoryAllData,item)
      
      this.factoryAllData[numAll].hidden = true
      let numCollect = search(this.factoryCollectData,item)
      console.log(numCollect)
      if (numCollect === false){
        
        
      }else{
        this.factoryCollectData[numCollect].hidden = true
      }
      function search(arr,dst){
        
        for(let j = 0 ; j < arr.length ; j ++){
          console.log(arr[j].factory_id)
          if (arr[j].factory_id == dst.factory_id){
            
            return j;
          }
     }
     return false;
    }
      this.factoryAllData[e].hidden = true
      console.log(this.factoryAllData)
      function unique1(arr) {
        var hash = [];
        for (var i = 0; i < arr.length; i++) {
          if (hash.indexOf(arr[i]) == -1) {
            hash.push(arr[i]);
          }
        }
        return hash;
      }
      this.factoryChoose = unique1(this.factoryChoose);
    },
    cancel(e) {
      let num = search(this.factoryAllData,this.factoryChoose[e])
      let numCollect = search(this.factoryCollectData,this.factoryChoose[e])
      console.log(this.factoryChoose[e])
      this.factoryAllData[num].hidden = false
      this.factoryCollectData[num].hidden = false
      this.factoryChoose.splice(e, 1);
      function search(arr,dst){
        
        for(let j = 0 ; j < arr.length ; j ++){
          console.log(arr[j].factory_id)
          if (arr[j].factory_id == dst.factory_id){
            
            return j;
          }
     }
     return false;
    }
    },
    launchTender(){                       //发起招标
        this.$http
        .post("/v2/validate/LaunchTender", {
          id:this.id,
          factory:this.factoryChoose,
        })
        .then(res => {
          alert("发布成功")
          this.$router.push({
            name: "Offer",
            query: {
              id: this.id
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getBidId() {
      this.id = this.$route.query.id;
      console.log(this.id);
    },
    radioChange(val) {
      if (this.orderType == "asc") {
        this.orderType = "desc";
        this.x = false;
      } else {
        this.orderType = "asc";
        this.x = true;
      }
      this.radio = val;
      //this.search({radio:this.radio})
    },
      handleSizeChange(val) {
        this.formData.limit = val;
        this.searchFactory()
      },
      handleCurrentChange(val) {
        this.formData.page = val;
        this.searchFactory()
      },
    collect(index){
      if (this.factoryAllData[index].collect == true){
        this.factoryAllData[index].collect = false
      }else{
        this.factoryAllData[index].collect = true
      }
      this.$http
        .post("/v2/validate/CollectFactory", {
          factoryId : this.factoryAllData[index].factory_id
        })
        .then(res => {
          
        })
        .catch(error => {
          console.log(error);
        });
    },
    CancelCollect(e){
      this.centerDialogVisible = true
      this.cancelCollect = e
    },
    dialog(e){
      this.centerDialogVisible = false
      console.log(this.cancelCollect)
      if (e){
        this.$http
        .post("/v2/validate/CollectFactory", {
          factoryId : this.factoryCollectData[this.cancelCollect].factory_id
          
        })
        .then(res => {
          
        })
        .catch(error => {
          console.log(error);
        });
      this.factoryCollectData.splice(this.cancelCollect, 1);
      }
      
    }
  },
  created() {
    this.searchFactory();
    this.getBidId();
  }
};
</script>

<style scoped>
.chooseFactory {
  width: 1400px;
  margin: 0 auto;
}
.chooseFactory .title p {
  font-size: 30px;
  color: #221e1f;
  margin: 20px 0;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.el-col .el-col-24 {
  margin-bottom: 15px;
}

.el-radio-group {
  padding-left: 20px;
}

.el-col .el-col-8 {
  display: flex;
  height: 300px;
  align-items: center;
}

.el-col .el-col-13 {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: black;
}
.el-col .el-col-13 h3 {
  font-size: 20px;
  font-weight: bold;
}
.el-col .el-col-13 p {
  font-size: 16px;
}

.el-col-3 {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-button-xzcs {
  background-color: #377bf1;
  color: white;
  font-weight: 400;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.cs-title {
  text-align: center;
  line-height: 40px;
  width: 97px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
}

.factory {
  height: 1000px;
}
.icon{
  text-align: right;
  font-size: 45px;
  color : orange
}
.pagination{text-align: center;margin-bottom: 25px;}
.remove{
  color: #377bf1
}
</style>